var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 222,
    width: 222,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 111,
    fill: "#222e3b",
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.452 32.538v32.721a62.8 62.8 0 0 0 -86.115.467v-32.442a89.708 89.708 0 0 1 86.115-.746z",
    fill: "#eeae53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.43 28.832 13.126 23.21a62.964 62.964 0 0 0 -38.481 39.178l-15.775-27.529a89.7 89.7 0 0 1 41.13-34.859z",
    fill: "#6da670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.805 111.207a62.506 62.506 0 0 0 6.388 27.6l-12.352 12.146-20.1-35.062a90.41 90.41 0 0 1 -.134-4.814 88.568 88.568 0 0 1 16.922-52.164l19.426 18.087a62.461 62.461 0 0 0 -10.15 34.207z",
    fill: "#80b283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.061 60.981-15.84 27.519a62.973 62.973 0 0 0 -39.737-37.215l13.381-23.562a89.664 89.664 0 0 1 42.196 33.258z",
    fill: "#ff7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.225 57.072a88.582 88.582 0 0 1 18.253 52.917l-23.52 40.861-10.683-10.46a62.737 62.737 0 0 0 -3.944-64.873z",
    fill: "#e85757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.058 200.257a89.314 89.314 0 0 1 -89.448-89.18c0-1.032.043-2.053.078-3.077h26.2q-.08 1.593-.081 3.207a62.834 62.834 0 0 0 125.669 0q0-1.612-.081-3.207h27.035c.035 1.024.078 2.045.078 3.077a89.314 89.314 0 0 1 -89.45 89.18z",
    fill: "#34495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.311 114.9a8.9 8.9 0 1 1 -16.785-5.892 3.016 3.016 0 0 1 .715-1.323l24.732-45.72-8.435 51.546a2.846 2.846 0 0 1 -.227 1.389z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedSync);
export default __webpack_public_path__ + "static/media/speedSync.813fe0641bf8d4c35c978203f79b516e.svg";
export { ForwardRef as ReactComponent };